import type { Libraries } from '@react-google-maps/api';

// @react-google-maps/api's useJsApiLoader wraps a page-wide singleton Loader
// (from @googlemaps/js-api-loader). If any two components call it with a
// different `id` or a different `libraries` set, the second call throws
// ("Loader must not be called again with different options"), and that
// page's `isLoaded` never becomes true until a full page reload resets the
// singleton. Every caller in this app MUST use these exact same constants.
export const GOOGLE_MAPS_LOADER_ID = 'google-maps-script';
export const GOOGLE_MAPS_LIBRARIES: Libraries = ['geometry', 'places'];
